import React from 'react';
import styles from '../styles/components/ModalButton.module.css';
import Modal from './Modal';
import { ActionButton, ActionButtonProps } from './ActionButton';

type ModalButtonProps = Omit<ActionButtonProps, 'onClick'> & {
  content: (doClose: () => void, modal?: boolean) => React.ReactNode;
};

const ModalButton: React.FC<ModalButtonProps> = props => {
  const [modal, setModal] = React.useState(false);
  const doOpen = () => setModal(true);
  const doClose = () => setModal(false);
  return (
    <div className={styles.container}>
      <div className={styles.buttonWrapper}>
        <ActionButton {...props} onClick={doOpen} />
      </div>
      <div className={styles.modalWrapper}>
        {modal && (
          <Modal onClose={doClose}>{props.content(doClose, modal)}</Modal>
        )}
      </div>
    </div>
  );
};

export default ModalButton;
